import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import { NAV_MAIN, NAV_SECONDARY } from './nav';

// Нижние вкладки (NewAdminLayout) — эти разделы уже видны без «Ещё»
// (Категории — во вкладках по просьбе владельца, Клиенты — здесь)
const TAB_PATHS = ['/admin', '/admin/products', '/admin/orders', '/admin/categories'];

export default function MorePage() {
  const navigate = useNavigate();
  const { user } = useApp();
  const isFullAdmin = user?.is_admin && (user?.role === 'owner' || user?.role === 'developer');

  // Верхняя группа, которой нет во вкладках (Рассылки), + нижний блок —
  // тот же состав и порядок, что в боковом меню веб-версии (nav.js).
  const extra = NAV_MAIN.filter(
    (i) => !TAB_PATHS.includes(i.path) && (!i.ownerOnly || isFullAdmin)
  );
  const secondary = NAV_SECONDARY.filter((i) => !i.ownerOnly || isFullAdmin);

  const renderItem = ({ path, label, Icon }) => (
    <button
      key={path}
      onClick={() => navigate(path)}
      className="flex w-full items-center gap-3 rounded-2xl bg-white p-4 ring-1 ring-[#e2e8f0] transition hover:bg-[#f1f5f9] active:scale-[0.99]"
    >
      <div className="grid h-10 w-10 place-items-center rounded-xl bg-[#64748b]/15 text-[#64748b]">
        <Icon className="h-5 w-5" />
      </div>
      <span className="text-sm font-medium text-[#0f172a]">{label}</span>
    </button>
  );

  return (
    <div className="px-4 py-4 space-y-2 animate-fade-in">
      {extra.map(renderItem)}

      {secondary.length > 0 && (
        <div className="px-1 pt-3 pb-1 text-[11px] font-semibold uppercase tracking-wide text-[#94a3b8]">
          Сайт и администрирование
        </div>
      )}
      {secondary.map(renderItem)}

      {/* Разделитель */}
      <div className="py-2" />

      {/* Выйти в магазин */}
      <button
        onClick={() => navigate('/')}
        className="flex w-full items-center gap-3 rounded-2xl bg-white p-4 ring-1 ring-[#e2e8f0] transition hover:bg-[#D64545]/10 active:scale-[0.99]"
      >
        <div className="grid h-10 w-10 place-items-center rounded-xl bg-[#D64545]/15 text-[#D64545]">
          <LogOut className="h-5 w-5" />
        </div>
        <span className="text-sm font-medium text-[#D64545]">Выйти в магазин</span>
      </button>
    </div>
  );
}
